import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

const Logout = () => {
  const history = useHistory();

  useEffect(() => {
    // Check if a user is already logged in
    const user = firebase.auth().currentUser;

    if (user) {
      // If user is logged in, log them out
      firebase.auth().signOut().then(() => {
        console.log('User logged out');
      }).catch((error) => {
        console.error('Error logging out:', error);
      });
      // Redirect to / after login
      history.push('/login');
      window.location.reload();
    }
  }, []);

  return (
    <div>
    </div>
  );
};

export default Logout;